module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAS0lEQVQ4jWN88fr9fwYaACZaGDpqMApgIaQgKCyR4c3bdyhiIsJCDOtWzcerj3E0VcAARhhjC1NCAFuYj4YxHIymY9obPJqOh7DBAFYMKvVsQH/DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jztb1-2.png
// module id = 413
// module chunks = 0